export default "__VITE_ASSET__COFBeQDN__$_?url__"